const TAKE_ME_BACK = 'Take me back to'
const HOME_PAGE = 'Home page'

export { TAKE_ME_BACK, HOME_PAGE }
